// extracted by mini-css-extract-plugin
module.exports = {"Container":"styles_Container__3elUa","UserInfoContainer":"styles_UserInfoContainer__24eq_"};